/**
 * Centralized Route to Menu Mapping Configuration
 * Maps child/edit/detail routes to their parent menu items
 * 
 * This ensures consistent side menu highlighting across the application
 * when navigating to related pages (e.g., Add/Edit pages highlight parent List menu)
 */
export const ROUTE_TO_MENU_MAPPING = {
  // Administration - User Management
  'addedituser': 'userlist',
  'addedituser/:id': 'userlist',
  
  // Administration - Lab Management
  'addeditlab': 'lablist',
  'addeditlab/:id': 'lablist',
  
  // Administration - Customer Management
  'addeditcustomer': 'CustomerList',
  'addeditcustomer/:id': 'CustomerList',
  'customerchars/:id': 'CustomerList',
  
  // Administration - Role Management
  'addeditrole/:id': 'rolelist',
  
  // Administration - Digital Signatures
  'addeditnabllogo': 'nabllogos',
  'addeditnabllogo/:id': 'nabllogos',
  
  // Analysis - Sample Status
  'addeditsample': 'samplestatus',
  'addeditsample/:id': 'samplestatus',
  'importsample': 'samplestatus',
  'addsampleresults/:id': 'samplestatus',
  'ferrographysampleresults/:id': 'samplestatus',
  'approvesampleresults/:id': 'samplestatus',
  'approveferroresults/:id': 'samplestatus',
  'samples': 'samplestatus',
  
  // Analysis - Job Card
  'addeditjobcard': 'jobcardlist',
  'addeditjobcard/:id': 'jobcardlist',
  'jobcardchars/:id': 'jobcardlist',
  'sendmail/:id': 'jobcardlist',
  
  // Report Configuration - Product Grades
  'addproductgrades': 'productgradeslist',
  'addproductgrades/:id': 'productgradeslist',
  
  // Report Configuration - Analysis Report Config
  'editanalysiselements/:id': 'analysisreportconfiglist',
  
  // Global Registry - Graph Templates
  'addeditgraphconfig/:id': 'graphtemplates',
  
  // Global Registry - Equipment (SPID)
  'addeditequipment': 'equipments',
  'addeditequipment/:id': 'equipments',
  'spidchars/:id': 'equipments',
  
  // Global Registry - Lubricant Chars
  'addlubricantchar/:id': 'lubricanttypes',
  
  // User Profile
  'edituserprofilesettings': 'userprofiledetails'
};
